<template>
  <div
    style="
      width: 100%;
      min-height: 100vh;
      padding-bottom: 4.33333rem;
      background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;
    "
  >
    <div>
      <van-nav-bar
        :title="$t('video.video')"
        style="background: unset; color: #000"
      >
        <template #right>
          <van-icon
            name="chat-o"
            size="24"
            color="#000"
            @click="$router.push({ path: '/Notice' })"
          />
        </template>
      </van-nav-bar>
    </div>
    <div>
      <van-tabs
        v-model="active"
        title-inactive-color="rgb(68, 40, 137)"
        title-active-color="rgb(197, 113, 207)"
        line-height="10px"
        line-width="40px"
        @click="onChange"
      >
        <van-tab
          :title="item.name"
          :name="item.id"
          title-style="font-size:16px;line-height:50px;"
          v-for="(item, index) in videolitem"
          :key="item.id"
        >
          <template #title v-if="index == 0">
            <div style="display: flex">
              <div style="">{{ item.name }}</div>
              <div
                style="
                  color: rgb(197, 113, 207);
                  font-weight: bold;
                  background: url('/img/new.png') right top 5px / 100% no-repeat;
                  width: 30px;
                "
              ></div>
            </div>
          </template>
          <div>
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
              <van-list v-model="loading" :finished="finished" @load="onLoad">
                <div class="list-item" v-if="data && data.length > 0">
                  <div
                    class="movie-list-item"
                    v-for="(i, key) in data"
                    :key="key"
                    @click="toPlayVideo(i.id)"
                  >
                    <div
                      class="cover_img van-image van-image--round"
                      style="width: 100%; height: 120px"
                    >
                      <img :src="i.vod_pic" class="van-image__img" />
                    </div>
                    <div class="movie-list-item-bottom" style="bottom: 33px">
                      <div class="movie-time-div">
                        <span>{{ i.vod_name }}</span>
                      </div>
                      <div
                        class="movie-time-div"
                        style="
                          font-size: 12px;
                          background-color: rgba(0, 0, 0, 0.3);
                        "
                      >
                        {{ $t("video.play") }} :{{ i.count }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="!loading" style="padding: 24px 0">
                  <van-empty :description="$t('withdraw.empty_data')" />
                </div>
              </van-list>
            </van-pull-refresh>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div style="height: 55px"></div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      active: 888,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      videolitem: [],
      data: [],
      page: 0,
      id: 888,

      // 用來避免「切 tab 很快時，舊 response 覆蓋新 tab」的競態問題
      videoListSeq: 0,
    };
  },
  methods: {
    onLoad(isRefresh = false) {
      const seq = this.videoListSeq;
      if (isRefresh) {
        console.debug("isRefresh", isRefresh);
        this.page = 0;
        this.data = [];
      }

      this.loading = true;

      this.getVideoList(seq).then(() => {
        // 如果使用者已經切到別的 tab（或觸發了新的請求），這次就不要動 UI 狀態
        if (seq !== this.videoListSeq) return;

        this.loading = false;
        if (this.refreshing) {
          this.refreshing = false;
          Toast(this.$t("reservation.refresh"));
        }
      });
    },
    onChange(name) {
      // 任何 tab 切換都視為「新的查詢上下文」，舊的 response 一律丟棄
      this.videoListSeq += 1;
      this.id = name;
      this.active = name;
      this.finished = false;
      this.loading = true;
      this.page = 0;
      this.data = [];
      this.onLoad(true);
    },
    onRefresh() {
      // 下拉刷新也視為新的查詢上下文
      this.videoListSeq += 1;
      // 清空列表数据
      this.finished = false;
      this.loading = true;
      this.onLoad(true);
    },
    toPlayVideo(id) {
      this.$router.push({ path: "/PlayVideo", query: { id } });
    },
    getVideoList(seq = this.videoListSeq) {
      // 捕捉「送出請求當下」的 tab id，避免 response 回來時已經切 tab
      const requestTabId = this.id;

      return new Promise((resolve) => {
        this.$http({
          method: "get",
          data: { id: requestTabId, page: this.page },
          url: "video_list",
        })
          .then((res) => {
            // 如果 tab 已切換（或已發出更新的請求），這個 response 直接忽略
            if (seq !== this.videoListSeq || requestTabId !== this.id) {
              return resolve({ stale: true });
            }

            const list = res && res.data && res.data.data;
            if (Array.isArray(list) && list.length > 0) {
              this.data = this.data.concat(list);
              this.page++;
            } else {
              this.finished = true;
            }
            resolve({ stale: false });
          })
          .catch((error) => {
            // axios 封裝目前大多數情況不會走到 catch，但保險起見仍加上
            if (seq !== this.videoListSeq || requestTabId !== this.id) {
              return resolve({ stale: true });
            }
            console.error("Error fetching video list:", error);
            resolve({ stale: false, error });
          });
      });
    },
    toLogin(str) {
      this.$router.push({ path: str });
    },
    getVideoClass() {
      this.$http({
        method: "get",
        url: "video_class",
      }).then((res) => {
        const lanng = localStorage.getItem("lang");
        this.videolitem = res.data;
        const obj = { id: 888, name: "最新,new,最新の,새로운,नया" };
        this.videolitem.unshift(obj);
        this.videolitem.forEach((item) => {
          const parts = item.name.split(",");
          lanng == "zh"
            ? (item.name = parts[0])
            : lanng == "en"
            ? (item.name = parts[1])
            : lanng == "ja"
            ? (item.name = parts[2])
            : lanng == "kr"
            ? (item.name = parts[3])
            : (item.name = parts[4] || parts[1]);
        });
        console.debug("videolitem", this.videolitem);
      });
    },
  },
  created() {
    this.getVideoClass();
  },
};
</script>

<style scoped lang="less">
.van-nav-bar {
  background: linear-gradient(30deg, #7d76ef, #d63f8c);
}
/deep/ .van-tabs__wrap {
  height: 13vw;
  padding-bottom: 10px;
}
/deep/ .van-tabs__line {
  background-color: #c571cf;
}
/deep/ .van-nav-bar__title {
  color: #000;
}
/deep/ .van-loading__text {
  font-size: 32px;
  color: #000;
}
/deep/ .van-tabs__nav {
  background: unset;
}
/deep/ .van-list__finished-text {
  font-size: 32px;
  color: #000;
}
/deep/ .van-pull-refresh__head {
  height: 100px;
}
/deep/ .van-pull-refresh__text {
  font-size: 32px; /* 设置字体大小 */
  color: #000;
}

.list-item {
  display: flex;
  width: calc(100% - 7vw);
  margin: 10px auto;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
}
.movie-list-item {
  width: calc(50% - 16px);
  margin-bottom: -7vw;
}
.cover_img {
  border-radius: 0px;
}
.movie-list-item-bottom {
  position: relative;
  width: 100%;
  bottom: 6vw;
}
.movie-time-div {
  background-color: rgba(0, 0, 0, 0.3);
  height: 8vw;
  color: #fff;
}
.movie-list-item-bottom div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 24vw;
  padding-left: 16px;
  font-size: 3vw;
}
.activeBg {
  color: rgb(197, 113, 207);
  font-weight: bold;
  background: url("/img/new.png") right top 5px / 30% no-repeat;
}
</style>
